import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row text-muted">
          <div className="col-6 text-start">
            <ul className="list-inline">
              <li className="list-inline-item">
                <a className="text-muted" href="#"></a>
              </li>
              <li className="list-inline-item">
                <a className="text-muted" href="#"></a>
              </li>
              <li className="list-inline-item">
                <a className="text-muted" href="#"></a>
              </li>
              <li className="list-inline-item">
                <a className="text-muted" href="#"></a>
              </li>
            </ul>
          </div>
          <div className="col-6 text-end">
            <p className="mb-0">
              © 2023 Jerusalem - Design By <a className="text-muted" href="https://www.gobeapp.com/" target="_blank" >GobeApp</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
